import script from "./ZhimaVideo.vue?vue&type=script&setup=true&lang=js"
export * from "./ZhimaVideo.vue?vue&type=script&setup=true&lang=js"

import "./ZhimaVideo.vue?vue&type=style&index=0&id=137a10df&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-137a10df"]])

export default __exports__